import { useQuery } from "@tanstack/react-query";
import { fetchRules } from "../api/rules";

export default function useRulesQuery() {
    return useQuery({
        queryKey: ["wahchan", "rules"],
        queryFn: ({ signal }) => fetchRules({ signal }),
        staleTime: 5 * 60 * 1000,
        refetchOnWindowFocus: false,
    });
}
